import React from 'react';
import { Row, Col, Card } from 'antd';
import TicketsFilter from "./TicketsFilter";
import TicketsTable from './TicketsTable';

export default function CheckedTickets() {

    return (
        <Card>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <TicketsFilter />
                </Col>
                <Col span={24}>
                    <TicketsTable ticketTypes="close"/>
                </Col>
            </Row>
        </Card>
    )
}